module.exports = __webpack_public_path__ + "static/img/form_liegend2.1de4831a.png";